import React from "react";

function UpdateBanner({ message }) {
  if (!message) {
    return null;
  }

  return (
    <div className="update-banner" role="status" aria-live="polite">
      <div className="update-banner__inner">
        <strong>Upcoming update</strong>
        <span>{message}</span>
      </div>
    </div>
  );
}

export default UpdateBanner;
